import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Caption1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { getProjectNameWithIdSelector } from "~/store/selectors/selector.projects";
import { FormatLocalDate } from "../Formatters";
import UserLink from "../UserLink/UserLink";

export const Metadata = ({ className, projectId, createdById, createdByEmail, createdByName, createdOn }) => {
  const { t } = useTranslation();

  const projectName = useSelector((state) => getProjectNameWithIdSelector(state, projectId));

  return (
    <div className={classNames("tw-flex tw-items-center", className)}>
      <Caption1
        color="tertiary"
        className="tw-pr-3 tw-mr-3 tw-border-border-primary tw-border-0 tw-border-solid tw-border-r"
      >
        <Link
          className="tw-no-underline tw-text-theme-600 hover:tw-text-secondary"
          to={`/projects/${projectId}`}
        >
          {projectName}
        </Link>
      </Caption1>
      <Caption1 color="tertiary">
        {t("Created by")}{" "}
        <UserLink
          id={createdById}
          hideAvatar
          renderAs={Caption1}
          email={createdByEmail}
          nameProps={{
            color: "tertiary",
          }}
          name={createdByName}
          context="note - started-by"
        />{" "}
        {t("on")}{" "}
        <FormatLocalDate
          value={createdOn}
          long={false}
        />
      </Caption1>
    </div>
  );
};

Metadata.propTypes = {
  className: PropTypes.string,
  projectId: PropTypes.number.isRequired,
  createdById: PropTypes.number,
  createdByName: PropTypes.string.isRequired,
  createdByEmail: PropTypes.string.isRequired,
  createdOn: PropTypes.number.isRequired,
};
